module.exports = __webpack_public_path__ + "static/media/impetraLogoWhite.8f906c15.png";